import type { ClientInfraNotes } from './index';

export const ARIZONA_CLIENT_ID = '6361162879';

export const arizonaNotes: ClientInfraNotes = {
  clientName: 'State of Arizona',
  protocol: {
    actual: 'TS over SRT',
    note: 'Despite rtmp:// in the URI, all Haivision encoders use SRT',
  },
  portPattern: '10100 + encoder number (e.g., AZ-Encoder5 = port 10105)',
  configLocation: {
    system: 'Wowza Streaming Engine Manager',
    path: 'srcEncoders application → Stream Files',
    credentials: '1Password → search "Ingress monitoring - Wowza"',
    url: 'http://ingress.state-oregon-cloud.invintus.stream:8088/enginemanager/login.htm',
  },
  notes: [
    {
      title: 'Shared Wowza server',
      description: 'Arizona streams are on the Oregon cloud Wowza server, not ingress.w1.invintus.com as the database URIs suggest.',
    },
    {
      title: 'Probe hostname mapping',
      description: 'Probes automatically translate w1 hostnames to state-oregon-cloud for AZ- prefixed streams.',
    },
  ],
};
